// extracted by mini-css-extract-plugin
export default {"common":"Text_common__khT8z","p1":"Text_p1__PcfwA","p2":"Text_p2__-jeDZ","footer":"Text_footer__ZumHq","base__dark":"Text_base__dark__odETF","base__light":"Text_base__light__Ha76l"};